import React, { useState, useEffect } from 'react';
import SEO from '../components/seo';
import Swal from 'sweetalert2';
import Image from '../images/icon.png';
import Layout from '../components/layout';
import Banner from '../components/banner';
import { FaRegUser, FaStar, FaCodeBranch } from 'react-icons/fa';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const Index = () => {
  const [repos, setRepos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [coppied, setCoppied] = useState(false);
  useEffect(() => {
    async function fetchData(){
      const response = await fetch('https://api.github.com/search/repositories?q=topic:gatsbyjs+topic:gatsby+topic:GatsbyJS+topic:Gatsby&sort=updated&order=desc&per_page=100');
      const data = await response.json();
      const item = data.items;
      setRepos(item);
      setLoading(false);
    }
    fetchData();
  }, []);
  return(
  <Layout>
    <SEO title=' ' />
    <Banner />
    <div className='ContentStyle'>
      <div className='masonry'>
        {loading ? <h1>Fetching Repos...</h1> : repos.map((data, i) => (<div key={ i } className='card'>
          <h2><FaRegUser className='ico' /> { data.owner.login }</h2>
          {data.owner.avatar_url ? <img src={ data.owner.avatar_url } alt={ data.name } loading='lazy' className='cardImage' /> : <img src={ Image } alt={ data.name } loading='lazy' className='cardImage' />}
          <div className='starBar'>
            {data.stargazers_count ? <p><FaStar className='ico star' /> { data.stargazers_count }</p> : <p><FaStar className='ico star' /> 0</p>}
            {data.forks_count ? <p><FaCodeBranch className='ico fork' /> { data.forks_count }</p> : <p><FaCodeBranch className='ico fork' /> 0</p>}
          </div>
          <div className='des'>
            {data.name ? <h3>{ data.name }</h3> : <h3>No Title Found!</h3>}
            {data.description ? <p title={ data.description }>{ `${ data.description.slice(0, 100) }...` }</p> : <p>No description found!</p>}
            {data.html_url ? <a href={ data.html_url } title='View Content!' target='_blank' rel='noopener noreferrer'><button className='btn'>View Repo!</button></a> : null}
            {data.clone_url ? <CopyToClipboard text={ data.clone_url } onCopy={ () => setCoppied(true) }>
              <button onClick={ () => Swal.fire({ title: 'Success!', text: `The clone URL for ${ data.name } has been coppied to your clipboard!`, type: 'success' }) } className='btn'>Clone Repo!</button>
            </CopyToClipboard> : null}
          </div>
        </div>))}
      </div>
    </div>
  </Layout>
  );
}
export default Index;
